import { formatShortDateWithWeekday } from "@clipboard-health/date-time";
import { Pill, Text } from "@clipboard-health/ui-components";
import { ButtonBase, Stack } from "@mui/material";
import { type MouseEvent } from "react";

interface InterviewDatePillsProps {
  interviewDays: string[];
  onDatePillClick: (event: MouseEvent, interviewDate: string) => void;
  onSeeAllClick: (event: MouseEvent) => void;
}

export function InterviewDatePills(props: InterviewDatePillsProps) {
  const { interviewDays, onDatePillClick, onSeeAllClick } = props;

  return (
    <Stack spacing={2}>
      <Text variant="caption" sx={(theme) => ({ color: theme.palette.text.secondary })}>
        Interview dates
      </Text>
      <Stack direction="row" spacing={1} flexWrap="wrap" rowGap={1}>
        {interviewDays.slice(0, 3).map((interviewDay) => {
          const formattedDate = formatShortDateWithWeekday(interviewDay);
          return (
            <ButtonBase
              key={interviewDay}
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                onDatePillClick(event, interviewDay);
              }}
            >
              <Pill label={formattedDate} size="small" variant="outlined" />
            </ButtonBase>
          );
        })}
        {interviewDays.length > 3 && (
          <ButtonBase
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
              onSeeAllClick(event);
            }}
          >
            <Pill label="See all" size="small" variant="outlined" />
          </ButtonBase>
        )}
      </Stack>
    </Stack>
  );
}
